<template>
  <div class="event-child" v-if="hasScanner">
    <Alert></Alert>

    <v-row class="align-center d-flex flex-column">
      <v-btn @click.prevent="checkIn" color="primary" class="mb-5">Участник</v-btn>
      <v-btn @click.prevent="mandateCheckIn" class="mb-5">Участник с пълномощно</v-btn>
    </v-row>
  </div>
</template>

<script>
import Alert from '@/components/Utils/Alert.vue'

export default {
  name: 'EventCheckIn',
  components: { Alert },

  mounted () {
    if (!this.hasScanner) {
      this.$store.commit('showAlert', { type: 'error', message: 'Чек-ин може да се извършва само от устройство с камера.' })
    }
  },

  computed: {
    hasScanner () {
      return typeof window.cordova !== 'undefined'
    },
    event () {
      return this.$store.getters.event
    }
  },

  methods: {
    checkIn () {
      this.$store.dispatch('qrScan')
        .then(contents => {
          if (contents.event && contents.event.id && contents.user) {
            this.$store.dispatch('checkInUser', { user: contents.user, mandate: false })
              .then(() => {
                alert('Потребител ' + contents.user + ' беше успешно чекиран.')
              })
              .catch(err => alert(err.response.data.error))
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    mandateCheckIn () {
      this.$store.commit('toggleQrScanner', true)

      let user, mandate

      this.$store.dispatch('qrScan')
        .then(contents => {
          if (contents.event && contents.event.id && contents.user) {
            mandate = contents.user
            alert('Пълномощник: ' + contents.user)

            this.$store.dispatch('qrScan')
              .then(contents => {
                if (contents.event && contents.event.id && contents.user) {
                  user = contents.user

                  this.$store.dispatch('checkInUser', { mandate, user })
                    .then(() => {
                      alert('Потребител ' + user +
                        ' беше успешно чекиран с пълномощник: ' +
                        mandate + '.')
                    })
                    .catch(err => alert(err.response.data.error))
                }

                this.$store.commit('toggleQrScanner', false)
              })
              .catch(err => {
                console.log(err)
                this.$store.commit('toggleQrScanner', false)
              })
          }
        })
        .catch(err => {
          console.log(err)
          this.$store.commit('toggleQrScanner', false)
        })
    }
  }
}
</script>
